// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Gicr-","eachCategory":"styles_eachCategory__aPkYg","title":"styles_title__NJOOR","category":"styles_category__e5PBH","content":"styles_content__BGa34"};